import {
  computePresetRange,
  type OffersDatePreset,
  type OffersPresetTimezoneMode,
} from "./presets"

export function runPreset(
  preset: OffersDatePreset,
  timezoneMode: OffersPresetTimezoneMode,
  apply: (
    p: OffersDatePreset,
    start: string,
    end: string,
    label: string,
  ) => void,
) {
  const r = computePresetRange(preset, new Date(), timezoneMode)
  apply(preset, r.startDate, r.endDate, r.displayLabel)
}
